import axiosInstance from "./axiosInstance";

const getDates = async (dateFrom = '', dateTo = '') => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/reservatio-obtenerFechas?date_from=${dateFrom}&date_to=${dateTo}`,
    {
      withCredentials: true,
    }
  );
  // if (dateFrom.trim().length > 0 && dateTo.trim().length > 0) {
  //   return await axiosInstance.get(
  //     `${process.env.REACT_APP_RESERVATIO_URL}/available_dates?date_from=${dateFrom}&date_to=${dateTo}`,
  //     {
  //       headers: {
  //         Token: process.env.REACT_APP_RESERVATIO_TOKEN,
  //       },
  //     }
  //   );
  // }

  // return await axiosInstance.get(
  //   `${process.env.REACT_APP_RESERVATIO_URL}/available_dates`,
  //   {
  //     headers: {
  //       Token: process.env.REACT_APP_RESERVATIO_TOKEN,
  //     },
  //   }
  // );
};

export default getDates;
